export type AppConfig = {
  environment: string;
  bucket_s3: string;
  captcha_site_key?: string;
  redirect_recruiter?: string;
  redirect_manager?: string;
  redirect_admin?: string;
  redirect_personal_account?: string;
  redirect_assessments?: string;
  redirect_sso?: string;
  sso_url?: string;
  mixpanel_token?: string;
  mixpanel_proxy?: string;
  viktor_url?: string;
  cdn_legacy_url?: string;
  chatbot_support_url?: string;
  chatbot_support_key?: string;
  client_token?: string;
};

export function fetchEnv(): Promise<AppConfig> {
  const base = import.meta.env.VITE_API_URL ?? window.location.origin;
  const path = `${base}/api/config.json`;

  // credentials: le front est servi depuis S3 et le gateway vit sur un autre
  // host, donc sans ça la requête part sans cookies. Or c'est le seul appel
  // /api/* qui précède le montage du router : c'est là que EnsureAuthIndicator
  // doit voir l'access_token posé par le BO pour reposer af-auth avant que le
  // premier garde ne décide.
  return fetch(path, { credentials: 'include' }).then(res => {
    if (!res.ok) throw new Error(`Failed to load config: ${res.status}`);
    return res.json();
  });
}

// Singleton — populated once in app.ts after fetchEnv()
let _config: AppConfig | null = null;

export function setConfig(config: AppConfig): void {
  _config = config;
}

export function getConfig(): AppConfig {
  if (!_config) throw new Error('Config not loaded');
  return _config;
}
